export const INVOICES_FILTERS_KEYS = {
  grossValueLessThan: 'grossValueLessThan',
  grossValueGreaterThan: 'grossValueGreaterThan',
  issuedAtStart: 'issuedAtStart',
  issuedAtEnd: 'issuedAtEnd',
  series: 'series',
  invoiceIds: 'invoicesIds',
  code: 'code',
  customersIds: 'customersIds',
  ordersIds: 'ordersIds',
  dateShortcut: 'dateShortcut',
  dateShortcutStep: 'shortcutStep',
  brands: 'brandIds',
  status: 'status',
};
